module.exports = {"pathContext":{"slug":"/es/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es.json
// module id = 770
// module chunks = 167051845407797